import React from 'react'
import st from './VacationInfo.module.scss'

export default function VacationInfo({
  contract: { left_vacation_mins, vacation_mins, left_vacation_years },
  translate,
  contract,
}) {
  const vacationInfoColor = () => {
    const now = Date.now()
    const dateFrom = new Date(contract.date_from).getTime()
    const dateUntil = new Date(contract.date_until).getTime()
    if (dateUntil < now) {
      return 'last'
    } else if (dateFrom <= now && now <= dateUntil) {
      return 'current'
    } else if (dateFrom > now) {
      return 'future'
    }
  }

  return (
    <div className={st.vacationInfo}>
      <div className={st.header}>
        <h5>{translate.vacation_information}</h5>
      </div>
      <div className={`${st.balanceDays} ${st[vacationInfoColor()]}`}>
        <div>
          <span>{translate.balance_today}</span>
          <span>
            {(left_vacation_mins / vacation_mins).toFixed(2)} {translate.days}
          </span>
        </div>
        <div>
          <span>{translate.remaining_days}</span>
          <span>
            {left_vacation_years.toFixed(2)} {translate.days}
          </span>
        </div>
      </div>
    </div>
  )
}
